import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { clamp } from "es-toolkit";
import { SDropdownV3, SField } from "../..";
import { useCallback, useEffect, useRef, useState } from "react";
export const DrawerPropertyEditor = ({ value, onChangeValue, readOnly, onClickValue })=>{
    const [activeIndex, setActiveIndex] = useState(0);
    const [startingPercentage, setStartingPercentage] = useState(undefined);
    const [sliderWidth, setSliderWidth] = useState(0);
    const sliderBackgroundRef = useRef(null);
    const { mouseDown, offset } = useMouseOffset();
    const setProps = (newProps)=>{
        const props = {
            type: "property-drawer",
            dismissible: true,
            detents: value?.detents || [],
            backgroundInteractive: false
        };
        onChangeValue?.({
            ...props,
            ...value,
            ...newProps
        });
    };
    useEffect(()=>{
        const newPercentage = clamp((startingPercentage || 0) + Math.round(offset.x / sliderWidth * 10000) / 100, 0, 100);
        if (activeIndex !== undefined && !isNaN(newPercentage) && value?.detents) {
            const newDetents = value.detents.map((point, i)=>{
                if (i === activeIndex) {
                    return {
                        ...point,
                        value: newPercentage.toString()
                    };
                }
                return point;
            });
            setProps({
                detents: newDetents
            });
        }
    }, [
        offset
    ]);
    useEffect(()=>{
        if (sliderBackgroundRef.current) {
            setSliderWidth(sliderBackgroundRef.current.offsetWidth);
        }
    }, [
        sliderBackgroundRef.current
    ]);
    const detents = value?.detents || [];
    return /*#__PURE__*/ _jsx("div", {
        onClick: onClickValue,
        children: /*#__PURE__*/ _jsx("div", {
            className: readOnly ? "pointer-events-none" : "",
            children: /*#__PURE__*/ _jsx(SField, {
                children: /*#__PURE__*/ _jsx("div", {
                    className: "flex flex-col gap-2 pl-2",
                    children: /*#__PURE__*/ _jsxs("div", {
                        className: "grid grid-cols-2 gap-3 items-center",
                        children: [
                            /*#__PURE__*/ _jsx("span", {
                                children: "Dismissible"
                            }),
                            /*#__PURE__*/ _jsx(SDropdownV3, {
                                borderless: false,
                                options: [
                                    {
                                        label: "Using gestures",
                                        value: "TRUE"
                                    },
                                    {
                                        label: "Manually",
                                        value: "FALSE"
                                    }
                                ],
                                value: value?.dismissible ? "TRUE" : "FALSE",
                                onChange: (transition)=>{
                                    setProps({
                                        dismissible: transition.value === "TRUE"
                                    });
                                }
                            })
                        ]
                    })
                })
            })
        })
    });
};
const useMouseOffset = ()=>{
    const [offset, setOffset] = useState({
        x: 0,
        y: 0
    });
    const [startPosition, setStartPosition] = useState({
        x: 0,
        y: 0
    });
    const [isTracking, setIsTracking] = useState(false);
    const mouseDown = useCallback((event)=>{
        setIsTracking(true);
        setStartPosition({
            x: event.clientX,
            y: event.clientY
        });
    }, []);
    const mouseUp = useCallback(()=>{
        setIsTracking(false);
        setStartPosition({
            x: 0,
            y: 0
        });
    }, []);
    useEffect(()=>{
        const onMouseMove = (event)=>{
            if (!isTracking) return;
            const offsetX = event.clientX - startPosition.x;
            const offsetY = event.clientY - startPosition.y;
            setOffset({
                x: offsetX,
                y: offsetY
            });
        };
        if (isTracking) {
            window.addEventListener("mousemove", onMouseMove);
            window.addEventListener("mouseup", mouseUp);
        } else {
            window.removeEventListener("mousemove", onMouseMove);
            window.removeEventListener("mouseup", mouseUp);
        }
        return ()=>{
            window.removeEventListener("mousemove", onMouseMove);
            window.removeEventListener("mouseup", mouseUp);
        };
    }, [
        isTracking
    ]);
    return {
        offset,
        mouseDown
    };
};
